import { NavigationGuard } from "vue-router";
import store from "@/store";
import { apolloClient } from "@/apollo";
import { START_ORDER } from "@/queries/anonymous/mutation.graphql";

export const ifNotAuthenticated: NavigationGuard = (to, from, next) => {
  if (!store.getters["authModule/isUserAuthenticated"]) {
    next();
    return;
  }
  next("/dashboard");
};

export const ifAuthenticated: NavigationGuard = (to, from, next) => {
  if (store.getters["authModule/isUserAuthenticated"]) {
    next();
    return;
  }

  next({ path: "/login", query: { redirectTo: to.path } });
};

export const startOrder = (to, from, next) => {
  const { menuId, tableId } = to.params;
  console.log(to);

  const variables = { menuId };
  if (tableId !== "generic") {
    variables["tableId"] = tableId;
  }

  apolloClient
    .mutate({
      mutation: START_ORDER,
      variables
    })
    .then(data => {
      if (data.data.startOrder) {
        localStorage.setItem("client_token", data.data.startOrder.tokenKey);
        localStorage.setItem("order_id", data.data.startOrder.orderId);
        localStorage.setItem("menu_id", menuId);
        localStorage.setItem("table_id", tableId);
        store.commit("authModule/setOrderId", data.data.startOrder.orderId);
        next();
        store.commit("loadersModule/toggleGlobalLoader", false);
      }
    })
    .catch(error => {
      store.commit("loadersModule/toggleGlobalLoader", false);
    });
};
